import { createContext } from 'react';
import { CustomUserType } from './adminFunctions';

type AuthContextType = { currentUser: CustomUserType | undefined };

export const AuthContext = createContext<AuthContextType>({ currentUser: undefined });
